export enum ReservationTabSideTopElement {
	'EVERYTHING_CORRECT' = 'EVERYTHING_CORRECT',
	'REVIEW_ON_BOOKING' = 'REVIEW_ON_BOOKING'
}
